import React, {InputHTMLAttributes, Ref} from 'react';
import {join, useId} from '@esgi/ui-kit/utils';
import {Omit} from 'react-beautiful-dnd';
import {Selectors} from '../controls.selectors';

import styles from './checkbox.module.less';

type BaseCheckboxAttributes = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'checked' | 'type'>

export type CheckboxProps = {
	checked: boolean;
	innerRef?: Ref<HTMLLabelElement>;
	'data-cy'?: string,
} & BaseCheckboxAttributes;

export function Checkbox(props: CheckboxProps): JSX.Element {
	const id = useId();
	const {className, innerRef, checked, disabled, children, readOnly, onChange, ...inputProps} = props;

	return <div className={join(styles.checkboxComponent, className)} data-name={id}>
		<input
			{...inputProps}
			id={props.id || id}
			type='checkbox'
			className={styles.checkboxInput}
			checked={checked}
			disabled={disabled}
			readOnly={readOnly || !onChange}
			data-cy={undefined}
			onChange={onChange}/>
		<label htmlFor={props.id || id}
		       data-cy={props['data-cy'] || Selectors.Checkbox}
		       ref={innerRef}
		       aria-disabled={disabled}
		       aria-checked={checked}
		       role='checkbox'
		       className={join(
			       styles.checkbox,
			       styles.indeterminatable,
			       checked && styles.checked,
			       checked === undefined && styles.indeterminate,
			       disabled && styles.disabled)}>
			{children}
		</label>
	</div>;
}
